<template>
  <div class="fl border-box h-95p" :style="'width:' + width">
    <div class="bor-deep-gra bg-wh h-100p ovf-auto">
      <p class="c-deep-blue p-t-20 p-b-20 p-l-10 p-r-10 m-t-0 m-b-0 bor-b-gray fw-b">
        <el-input v-model="input" placeholder="请输入控件名" @change="change"></el-input>
      </p>
      <div class="select-list">
        <div class="p-t-20 p-b-20 no-select drag p-l-30" v-for="(item, index) in tabInputsTemp" @mousedown="dragDown(item)">
          <i class="fa fz-24 c-blue no-select m-r-10" :class="item.icon"></i>
          {{item.name}}
        </div>
      </div>
    </div>
    <!-- 拖动标签 -->
    <div class="temp-drag" :style="dragStyle" v-show="curType.name && dragShow">
      <i class="fa fz-24 c-blue no-select m-r-10" :class="curType.icon"></i>
      {{curType.name}}
    </div>
    <!-- 拖动标签 -->
  </div>
</template>

<style>
  .select-list > div:hover {
    background-color: #eeeeee;
  }
  .temp-drag {
    position: absolute;
    width: 200px;
    padding: 20px 0;
    background-color: #fff;
    z-index: 0;
    cursor: move;
  }
</style>

<script>
  export default {
    props: ['tabInputs', 'curType', 'isDrag', 'width'],
    data() {
      return {
        dragStyle: {},  // 设置拖拽标签的位置
        dragShow: false,
        tabInputsTemp: []
      }
    },
    created() {
      this.init()
      this.tabInputsTemp = this.tabInputs
    },
    methods: {
      change(val) {
        let tabInputsTemp = []
        this.tabInputs.forEach((item) => {
          if (item.name.indexOf(val.trim()) > -1) {
            tabInputsTemp.push(item)
          }
        })
        this.tabInputsTemp = tabInputsTemp
      },
      init() {
        document.addEventListener('mousemove', (event) => {
          if (this.isDrag) {
            if (!this.dragShow) {
              this.dragShow = true
            }
            this.dragStyle = {
              top: event.pageY - 80 + 'px',
              left: event.pageX - 100 + 'px'
            }
          }
        })
      },
      dragDown(item) {  // 点击左侧栏，设置拖拽标识
        this.$emit('setIsDrag', true)
        this.$emit('setCurType', item)
      }
    },
    watch: {
      'curType.name'() {
        if (!this.curType.name) {
          this.dragShow = false
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// inputType.vue?623a664e